/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('urlEditor', [
  '$rootScope',

  function ($rootScope) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/url-editor.html'),

      replace: true,

      scope: {
        url: '=',
        method: '=',
      },

      link(scope, element, attrs) {
        if (!scope.method) {
          scope.method = 'GET';
        }

        scope.setMethod = function (method) {
          scope.method = method;
        };
      },
    };
  },
]);
